function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Box, Button, Dialog, Flex, Notice, ProgressIndicator, useId, useToasts } from '@applyboard/crystal-ui';
import { EyeFillIcon } from '@applyboard/ui-icons';
import { DynamicForm, DynamicFormPreview } from "../../../../components/DynamicForm";
import { LegacyRemoveFileDialog } from "../LegacyRemoveFileDialog";
import { useApplication, useLegacyApplicationRequirements, useApplicationPagePermissions, useDeleteApplicationRequirementAttachment, useUpdateLegacyApplicationRequirement, useUploadRequirementFile, usePollRequirement } from "../../data";
import { LightBulbAndGearsIllustration } from "../../../../illustrations";
import { useNow } from "../../../../utils/hooks";
import { differenceInSeconds } from 'date-fns';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function HybridRequirementDialogButton(_ref) {
  var requirementId = _ref.requirementId,
    _onSuccess2 = _ref.onSuccess,
    buttonImageUrl = _ref.buttonImageUrl,
    pastResponse = _ref.pastResponse;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    fileToDelete = _useState4[0],
    setFileToDelete = _useState4[1];
  var _useUploadRequirement = useUploadRequirementFile(),
    uploadRequirementFile = _useUploadRequirement.uploadRequirementFile;
  var _useUpdateLegacyAppli = useUpdateLegacyApplicationRequirement(),
    isUpdatingApplicationRequirement = _useUpdateLegacyAppli.isUpdatingApplicationRequirement,
    updateApplicationRequirement = _useUpdateLegacyAppli.updateApplicationRequirement;
  var _useDeleteApplication = useDeleteApplicationRequirementAttachment(),
    deleteRequirementAttachments = _useDeleteApplication.deleteRequirementAttachments,
    isDeletingRequirementAttachments = _useDeleteApplication.isDeletingRequirementAttachments;
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var _useApplicationPagePe = useApplicationPagePermissions(),
    permissions = _useApplicationPagePe.permissions;
  var requirement = applicationRequirements.find(function (requirement) {
    return requirement.id === requirementId;
  });
  var formHeadingId = useId();
  var toasts = useToasts();
  var onFileDeleteSuccess = function onFileDeleteSuccess(filename) {
    return toasts.positive("File \"".concat(filename, "\" successfully removed"));
  };
  if (!requirement || !requirement.formDefinition) {
    return null;
  }
  var isPreviewMode = requirement.status === 'status_completed' || requirement.status === 'status_reviewing' || pastResponse;
  var isPreparingRequirement = requirement.status === 'status_missing' && requirement.preparing;
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    size: "lg",
    children: [pastResponse ? _jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        leadIcon: EyeFillIcon,
        emphasis: "outlined",
        intent: "primary",
        size: "sm",
        "aria-label": "Review response"
      })
    }) : _jsx(Dialog.Trigger, {
      children: _jsx("button", {
        type: "button",
        "aria-label": "Fulfill Requirement: ".concat(requirement.title),
        style: {
          height: 38,
          width: 38,
          padding: 0,
          border: 'none',
          background: 'none'
        },
        children: _jsx("img", {
          alt: "",
          "aria-hidden": true,
          src: buttonImageUrl
        })
      })
    }), _jsx(Dialog.Heading, {
      children: _jsx("span", {
        id: formHeadingId,
        children: requirement.title
      })
    }), _jsx(Dialog.Content, {
      children: isPreparingRequirement ? _jsx(RequirementPreparingState, {
        requirementId: requirement.id
      }) : _jsxs(_Fragment, {
        children: [isPreviewMode ? _jsxs(_Fragment, {
          children: [_jsx(Box, {
            pb: 4,
            children: _jsx(PreviewModeNotice, {
              isPastAttempt: !!pastResponse,
              requirement: requirement
            })
          }), _jsx(DynamicFormPreview, {
            formDefinition: requirement.formDefinition,
            formData: pastResponse ? pastResponse : requirement.formData,
            files: requirement.files,
            onDeleteFileClick: permissions.destroy_requirement_attachment_for_pii ? function (fileId) {
              var fileToDelete = requirement.files.find(function (file) {
                return file.id === fileId;
              });
              if (fileToDelete) {
                setFileToDelete(fileToDelete);
              }
            } : undefined
          })]
        }) : _jsx(DynamicForm, {
          "aria-labelledby": formHeadingId,
          formDefinition: requirement.formDefinition,
          formData: requirement.pendingFormData,
          formFileInformation: generateFormFileInformation(requirement.attachments),
          uploadFile: function uploadFile(file, _ref2) {
            var _onSuccess = _ref2.onSuccess,
              _onError = _ref2.onError;
            uploadRequirementFile({
              applicationId: application.id,
              requirementId: requirement.newId,
              file: file
            }, {
              onSuccess: function onSuccess(response) {
                _onSuccess(response.data.id);
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                } else {
                  toasts.negative(new Error('An error occurred while uploading the file.'));
                }
                _onError();
              }
            });
          },
          onSubmit: function onSubmit(formValues, _ref3) {
            var setValues = _ref3.setValues;
            if (!requirement.formDefinition) {
              return;
            }
            updateApplicationRequirement({
              id: requirement.id,
              status: 'status_reviewing',
              ignoreFileWarnings: hasFilesWithWarnings(requirement.files),
              formData: formValues
            }, {
              onSuccess: function onSuccess(updatedAggregatedData) {
                var updatedRequirement = updatedAggregatedData.response.included.find(function (item) {
                  return item.type === 'application_hybrid_requirements' && item.id === requirement.id.toString();
                });
                if (updatedRequirement !== null && updatedRequirement !== void 0 && updatedRequirement.attributes.formData && _onSuccess2) {
                  _onSuccess2(_objectSpread({
                    id: updatedRequirement.id,
                    type: updatedRequirement.type
                  }, updatedRequirement.attributes));
                  if (updatedRequirement.attributes.status === 'status_reviewing') {
                    toasts.positive('Response submitted successfully!');
                    setIsOpen(false);
                  } else {
                    setValues(updatedRequirement.attributes.formData);
                  }
                }
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                }
              }
            });
          },
          isSaving: isUpdatingApplicationRequirement
        }), fileToDelete && _jsx(LegacyRemoveFileDialog, {
          applicationId: application.id,
          requirementId: requirement.id,
          isOpen: !!fileToDelete,
          isRemovingFile: isDeletingRequirementAttachments,
          onOpenChange: function onOpenChange(open) {
            if (!open) {
              setFileToDelete(undefined);
            }
          },
          attachmentId: fileToDelete.id,
          fileName: fileToDelete.name,
          onConfirmNonPiiDelete: function onConfirmNonPiiDelete() {
            deleteRequirementAttachments({
              attachmentId: fileToDelete.id,
              requirementId: requirementId
            }, {
              onSuccess: function onSuccess() {
                onFileDeleteSuccess(fileToDelete.name);
                setFileToDelete(undefined);
              },
              onError: function onError(error) {
                if (error instanceof Error) {
                  toasts.negative(error);
                } else {
                  toasts.negative(new Error('Something went wrong removing the file.'));
                }
              }
            });
          },
          onSuccess: function onSuccess() {
            return onFileDeleteSuccess(fileToDelete.name);
          },
          requirementType: "hybrid"
        })]
      })
    }), isPreviewMode && _jsx(Dialog.Actions, {
      children: _jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Close"
      })
    }), isPreparingRequirement && _jsx(Dialog.Actions, {
      children: _jsx(Button, {
        width: "fill",
        intent: "secondary",
        emphasis: "highlighted",
        onClick: function onClick() {
          return setIsOpen(false);
        },
        children: "Cancel"
      })
    })]
  });
}
function PreviewModeNotice(_ref4) {
  var isPastAttempt = _ref4.isPastAttempt,
    requirement = _ref4.requirement;
  if (isPastAttempt) {
    return _jsx(Notice, {
      intent: "negative",
      children: "Applicant\u2019s responses have been reviewed and did not pass evaluation. The responses submitted for this attempt can be found below."
    });
  }
  if (requirement.status === 'status_reviewing') {
    return _jsx(Notice, {
      intent: "primary",
      children: "Applicant\u2019s responses are being processed. No changes to the responses can be made while the requirement is in review."
    });
  }
  return _jsx(Notice, {
    intent: "positive",
    children: "Applicant\u2019s response has been reviewed and successfully completed. No changes to the response can be made since the requirement is completed now."
  });
}
export function RequirementPreparingState(_ref5) {
  var requirementId = _ref5.requirementId;
  var _usePollRequirement = usePollRequirement(requirementId),
    estimatedTimeUntilPrepared = _usePollRequirement.estimatedTimeUntilPrepared;
  var now = useNow();
  var preparingTime = estimatedTimeUntilPrepared ? differenceInSeconds(new Date(estimatedTimeUntilPrepared), now) : 0;
  return _jsxs(Flex, {
    align: "center",
    justify: "center",
    direction: "column",
    p: {
      xs: 0,
      md: 24
    },
    gap: 8,
    children: [_jsx(LightBulbAndGearsIllustration, {}), _jsx(ProgressIndicator, {
      alignment: "default",
      helpText: preparingTime > 0 ? "We estimate that it will take around ".concat(preparingTime, " second").concat(preparingTime > 1 ? "s" : '', ", but please note that it may be a bit longer. Feel free to try again later. Thank you for your patience!") : 'Just a moment…',
      indeterminate: true,
      label: "Please wait while we process your request.",
      size: "sm",
      variant: "linear"
    })]
  });
}
function hasFilesWithWarnings(files) {
  return files === null || files === void 0 ? void 0 : files.some(function (file) {
    return file.validationResults.some(function (result) {
      return result.status === 'negative' || result.status === 'warning';
    });
  });
}
function generateFormFileInformation(attachments) {
  var formFileInformation = {};
  var _iterator = _createForOfIteratorHelper(attachments || []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var attachment = _step.value;
      formFileInformation[attachment.id] = {
        name: attachment.fileName
      };
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return formFileInformation;
}